import { NextPage } from 'next'
import { Panel } from 'rsuite'
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine'
import Link from 'next/link'
import CenterLayout from '../components/shared/CenterLayout'
import CustomText from '../components/base/CustomText'
import { useAuthStore } from '../dataStores/auth'
import { VERSION_NUMBER } from '../config'

const Help: NextPage = () => {
  const user = useAuthStore((state) => state.user)

  const userFullName = encodeURIComponent(`${user?.first_name} ${user?.last_name}`)
  const userEmail = user ? encodeURIComponent(user.email) : ''
  const userParams = user ? `&Tu%20Correo%20Electr%C3%B3nico=${userEmail}&Tu%20Nombre%20Completo=${userFullName}` : ''
  const versionParam = VERSION_NUMBER
    ? `?${encodeURIComponent('Versión')}=${encodeURIComponent(VERSION_NUMBER.toString())}`
    : ''

  return (
    <CenterLayout maxWidth={700} showLogo>
      <Panel bodyFill shaded className="bg-white">
        <div>
          <div className="p-6">
            <CustomText size="heading-4" weight={600} className="text-center text-gray-darker">
              Opciones de Ayuda
            </CustomText>
          </div>
          <div>
            <div>
              <div className="divide-y divide-gray">
                <a
                  href={`https://forms.clickup.com/3025493/f/2wajn-2043/KC70VS5H6H5L3O6UN3${versionParam}${userParams}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 hover:bg-gray-light active:bg-gray flex items-center"
                >
                  <div className="flex-1 min-w-0">
                    <CustomText size="subtitle-2" weight={700} className="text-gray-darker truncate">
                      Formulario de Incidencias o Comentarios
                    </CustomText>
                    <CustomText size="caption" weight={400} className="text-gray-darker truncate">
                      Para problemas o mejoras en la aplicación.
                    </CustomText>
                  </div>
                  <ArrowRightLineIcon />
                </a>
                <a
                  href="https://elecnor-cdn.s3.amazonaws.com/assets/elecnor-manual-de-usuario.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 hover:bg-gray-light active:bg-gray flex items-center"
                >
                  <div className="flex-1 min-w-0">
                    <CustomText size="subtitle-2" weight={700} className="text-gray-darker truncate">
                      Manual de Usuario
                    </CustomText>
                    <CustomText size="caption" weight={400} className="text-gray-darker truncate">
                      Válido para todos los roles de usuario.
                    </CustomText>
                  </div>
                  <ArrowRightLineIcon />
                </a>
                <a
                  href="mailto:support@trazolabs.com?subject=Contacto%20desde%20Elecnor&body=Estimado%20Equipo%20Trazo%20Labs%2C"
                  className="p-4 hover:bg-gray-light active:bg-gray flex items-center"
                >
                  <div className="flex-1 min-w-0">
                    <CustomText size="subtitle-2" weight={700} className="text-gray-darker truncate">
                      Email de Contacto
                    </CustomText>
                    <CustomText size="caption" weight={400} className="text-gray-darker truncate">
                      support@trazolabs.com
                    </CustomText>
                  </div>
                  <ArrowRightLineIcon />
                </a>
                <Link href="/support/guides">
                  <a className="p-4 hover:bg-gray-light active:bg-gray flex items-center">
                    <div className="flex-1 min-w-0">
                      <CustomText size="subtitle-2" weight={700} className="text-gray-darker truncate">
                        Guías de Ayuda
                      </CustomText>
                      <CustomText size="caption" weight={400} className="text-gray-darker truncate">
                        Instrucciones paso a paso
                      </CustomText>
                    </div>
                    <ArrowRightLineIcon />
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Panel>
    </CenterLayout>
  )
}

Help.auth = false

export default Help
